import { render } from "./CompanyOrdersCard.vue?vue&type=template&id=50e1949f&scoped=true"
import script from "./CompanyOrdersCard.vue?vue&type=script&lang=js"
export * from "./CompanyOrdersCard.vue?vue&type=script&lang=js"

import "./CompanyOrdersCard.vue?vue&type=style&index=0&id=50e1949f&scoped=true&lang=css"

import exportComponent from "/Users/steve/Desktop/valet/rspremote/web/app/themes/rspremote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e1949f"]])

export default __exports__